/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgExternalLink = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-external-link_svg__st0{fill:currentcolor}'}</style>
    <path className="ico-external-link_svg__st0" d="M20 20H4V4h7V2H2v20h20v-9h-2z" />
    <path className="ico-external-link_svg__st0" d="M14 2v2h4.6L8.3 14.3l1.4 1.4L20 5.4V10h2V2z" />
  </Icon>
);
export { SvgExternalLink as ExternalLink };
